/*

 */


export const SYSTEM_STATS_DEFAULT_WIDTH = 300;
export const SYSTEM_STATS_DEFAULT_HEIGHT = 200;
